import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left Column - Company Info */}
          <div>
            <h3 className="text-2xl lg:text-3xl font-bold mb-6">
              おかやま解体工事株式会社
            </h3>
            <div className="space-y-4 text-white">
              <p className="flex items-start">
                <span className="font-medium mr-2">住所:</span>
                <span>〒700-0000 岡山市北区○○町1-2-3</span>
              </p>
              <p className="flex items-center">
                <span className="font-medium mr-2">電話番号:</span>
                <a href="tel:086-012-3456" className="hover:text-secondary transition-colors cursor-pointer">
                  086-012-3456
                </a>
              </p>
              <p className="flex items-center">
                <span className="font-medium mr-2">FAX番号:</span>
                <span>086-012-3457</span>
              </p>
              <p className="flex items-center">
                <span className="font-medium mr-2">営業時間:</span>
                <span>8:00 〜 17:00</span>
              </p>
            </div>
          </div>

          {/* Right Column - Navigation Menu */}
          <div>
            <h4 className="text-lg font-bold mb-6">メニュー</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-white hover:text-secondary transition-colors underline cursor-pointer">
                  トップ
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white hover:text-secondary transition-colors underline cursor-pointer">
                  事業案内
                </Link>
              </li>
              <li>
                <Link to="/works" className="text-white hover:text-secondary transition-colors underline cursor-pointer">
                  施工事例
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-white hover:text-secondary transition-colors underline cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/recruit" className="text-white hover:text-secondary transition-colors underline cursor-pointer">
                  採用情報
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-secondary transition-colors underline cursor-pointer">
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/30 mt-12 lg:mt-16 pt-8 flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0">
          <p className="text-white text-sm text-center">
            © 2025 おかやま解体工事株式会社
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-white hover:text-secondary transition-colors underline text-sm cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="#" className="text-white hover:text-secondary transition-colors underline text-sm cursor-pointer">
              利用規約
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white hover:text-secondary transition-colors underline text-sm cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
